document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

function formatMoney(cents) {
  const currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'PKR';
  return new Intl.NumberFormat('en-PK', { style: 'currency', currency, maximumFractionDigits: 0 }).format(Number(cents || 0) / 100);
}

function sizedShopifyImage(url, width = 240) {
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.set('width', String(width));
    return parsed.toString();
  } catch (error) {
    return url;
  }
}

function toast(message) {
  const el = $('#VoydToast');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  clearTimeout(window.voydToastTimer);
  window.voydToastTimer = setTimeout(() => el.classList.remove('is-visible'), 2200);
}

function lockBody() {
  document.body.classList.add('drawer-open');
}
function unlockBodyIfClear() {
  if (!$('.mobile-drawer.is-open') && !$('.cart-drawer.is-open') && !$('.search-drawer.is-open') && !$('.quick-buy-modal.is-open') && !$('.image-lightbox.is-open')) {
    document.body.classList.remove('drawer-open', 'menu-open');
  }
}
function showScrim() {
  const scrim = $('[data-drawer-scrim]');
  if (scrim) scrim.classList.add('is-visible');
}
function hideScrimIfClear() {
  if (!$('.mobile-drawer.is-open') && !$('.cart-drawer.is-open')) {
    const scrim = $('[data-drawer-scrim]');
    if (scrim) scrim.classList.remove('is-visible');
  }
}

function openMobileMenu() {
  const drawer = $('#MobileDrawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  $$('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
  document.body.classList.add('menu-open');
  lockBody();
  showScrim();
}
function closeMobileMenu() {
  const drawer = $('#MobileDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  $$('[data-menu-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  hideScrimIfClear();
  unlockBodyIfClear();
}

function openSearch() {
  const drawer = $('#SearchDrawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  lockBody();
  setTimeout(() => {
    const input = $('input[type="search"]', drawer);
    if (input) input.focus();
  }, 160);
}
function closeSearch() {
  const drawer = $('#SearchDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  unlockBodyIfClear();
}

function openCart() {
  const drawer = $('#CartDrawer');
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  $$('[data-cart-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
  lockBody();
  showScrim();
  refreshCartDrawer();
}
function closeCart() {
  const drawer = $('#CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  $$('[data-cart-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
  hideScrimIfClear();
  unlockBodyIfClear();
}

$$('[data-menu-open]').forEach(button => button.addEventListener('click', openMobileMenu));
$$('[data-menu-close]').forEach(button => button.addEventListener('click', closeMobileMenu));
$$('[data-search-open]').forEach(button => button.addEventListener('click', () => {
  closeMobileMenu();
  openSearch();
}));
$$('[data-search-close]').forEach(button => button.addEventListener('click', closeSearch));
$$('[data-cart-open]').forEach(button => button.addEventListener('click', openCart));
$$('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));
$$('[data-drawer-scrim]').forEach(scrim => scrim.addEventListener('click', () => {
  closeMobileMenu();
  closeCart();
}));

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    closeMobileMenu();
    closeCart();
    closeSearch();
    $$('.quick-buy-modal.is-open').forEach(closeQuickModal);
    const lb = $('[data-image-lightbox]');
    if (lb && lb.classList.contains('is-open')) { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden','true'); unlockBodyIfClear(); }
  }
});

$$('.mega-details').forEach(details => {
  details.addEventListener('toggle', () => {
    if (!details.open) return;
    $$('.mega-details').forEach(other => {
      if (other !== details) other.removeAttribute('open');
    });
  });
});
document.addEventListener('click', event => {
  if (!event.target.closest('.mega-details')) {
    $$('.mega-details[open]').forEach(details => details.removeAttribute('open'));
  }
});

function bindQuantityControls(context = document) {
  $$('[data-qty]', context).forEach(wrapper => {
    if (wrapper.dataset.qtyBound === 'true') return;
    wrapper.dataset.qtyBound = 'true';
    const input = $('input', wrapper);
    $$('button', wrapper).forEach(button => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.qtyChange || 0);
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}
bindQuantityControls();
window.VoydBindQuantity = bindQuantityControls;

function updateCartCounters(count) {
  $$('[data-cart-count]').forEach(el => el.textContent = count);
  $$('[data-cart-drawer-count]').forEach(el => el.textContent = count);
}

function shippingMessage(cart) {
  const drawer = $('#CartDrawer');
  if (!drawer) return '';
  const threshold = Number(drawer.dataset.freeShipping || 0);
  if (!threshold) return '';
  if (cart.total_price >= threshold) return 'FREE shipping unlocked.';
  return `Spend ${formatMoney(threshold - cart.total_price)} more for FREE shipping.`;
}

function renderDrawerCart(cart) {
  const drawer = $('#CartDrawer');
  if (!drawer) return;
  const items = $('[data-cart-items]', drawer);
  const total = $('[data-cart-total]', drawer);
  const progress = $('[data-cart-progress]', drawer);
  const message = $('[data-cart-shipping-message]', drawer);
  const threshold = Number(drawer.dataset.freeShipping || 0);

  updateCartCounters(cart.item_count);
  if (total) total.textContent = formatMoney(cart.total_price);
  if (progress) {
    const percentage = threshold ? Math.min(100, Math.round(cart.total_price * 100 / threshold)) : 0;
    progress.style.width = `${percentage}%`;
  }
  if (message) message.textContent = shippingMessage(cart);

  if (!items) return;
  if (!cart.items.length) {
    items.innerHTML = `<div class="drawer-empty"><p>Your cart is currently empty.</p><a class="button button--full" href="/collections/all">Shop all</a></div>`;
    return;
  }

  items.innerHTML = cart.items.map((item, index) => {
    const image = item.image ? `<a href="${item.url}"><img src="${sizedShopifyImage(item.image, 240)}" alt="${item.product_title.replace(/"/g, '&quot;')}" loading="lazy" decoding="async" width="120" height="160"></a>` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : '';
    return `<article class="drawer-item" data-line="${index + 1}">
      ${image}
      <div class="drawer-item__info">
        <a href="${item.url}">${item.product_title}</a>
        ${variant}
        <div class="drawer-item__bottom"><span>${formatMoney(item.final_line_price)}</span><button type="button" class="text-button" data-cart-remove="${index + 1}">Remove</button></div>
      </div>
    </article>`;
  }).join('');

}

async function fetchCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('cart');
  return response.json();
}

async function refreshCartDrawer() {
  try {
    const cart = await fetchCart();
    renderDrawerCart(cart);
  } catch (error) {}
}

async function changeCartLine(line, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('cart change');
    const cart = await response.json();
    renderDrawerCart(cart);
  } catch (error) {
    toast('Could not update cart');
  }
}

document.addEventListener('click', async event => {
  const removeButton = event.target.closest('[data-cart-remove]');
  if (removeButton && removeButton.closest('#CartDrawer')) {
    await changeCartLine(Number(removeButton.dataset.cartRemove), 0);
  }

  const quickAdd = event.target.closest('[data-quick-add]');
  if (quickAdd) {
    event.preventDefault();
    const original = quickAdd.textContent;
    quickAdd.textContent = 'Adding…';
    quickAdd.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(quickAdd.dataset.quickAdd), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('add');
      toast('Added to bag');
      await refreshCartDrawer();
      openCart();
    } catch (error) {
      toast('Could not add item');
    } finally {
      quickAdd.textContent = original;
      quickAdd.disabled = false;
    }
  }
});

function bindProductForms(context = document) {
  $$('[data-product-form]', context).forEach(root => {
  if (root.dataset.productBound === 'true') return;
  root.dataset.productBound = 'true';
  const form = root.closest('form');
  const json = $('[data-product-json]', root);
  if (!form || !json) return;

  let product;
  try {
    product = JSON.parse(json.textContent);
  } catch (error) {
    return;
  }

  const scope = root.closest('[data-product-root], [data-quick-modal]') || root;
  const idInput = $('[name="id"]', root);
  const price = $('[data-price]', scope);
  const compare = $('[data-compare]', scope);
  const stock = $('[data-stock]', scope);
  const submit = $('[type="submit"]', root);
  const label = $('[data-submit-label]', root);
  const notifyTrigger = $('[data-notify-open]', scope);

  function updateVariant() {
    const values = $$('fieldset[data-option-index]', root).map(fieldset => {
      const checked = $('input:checked', fieldset);
      return checked ? checked.value : null;
    });
    const variant = product.variants.find(item => item.options.every((option, index) => option === values[index]));
    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
    if (compare) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      compare.hidden = !hasCompare;
    }
    if (stock) {
      const urgencyRoot = stock.closest('[data-urgency-root]');
      const urgencyTitle = urgencyRoot ? $('[data-urgency-title]', urgencyRoot) : null;
      const urgencyMeterWrap = urgencyRoot ? $('.product-urgency__meter', urgencyRoot) : null;
      const urgencyMeter = urgencyRoot ? $('[data-urgency-meter]', urgencyRoot) : null;
      const threshold = urgencyRoot ? Number(urgencyRoot.dataset.lowStockThreshold || 10) : 10;
      const isLow = variant.available && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;

      if (!variant.available) {
        stock.textContent = 'Join the restock list and we’ll email you when it returns.';
        if (urgencyTitle) urgencyTitle.textContent = 'Currently unavailable';
      } else if (isLow) {
        stock.textContent = 'This size is moving fast from a limited drop.';
        if (urgencyTitle) urgencyTitle.textContent = `Low stock — only ${variant.inventory_quantity} left`;
      } else {
        stock.textContent = 'Limited drop. Popular sizes can sell through quickly.';
        if (urgencyTitle) urgencyTitle.textContent = 'In stock — secure your size';
      }

      if (urgencyMeterWrap) urgencyMeterWrap.hidden = !isLow;
      if (urgencyMeter) urgencyMeter.style.width = `${Math.min(100, Math.max(8, (variant.inventory_quantity / threshold) * 100))}%`;
    }
    if (submit) submit.disabled = !variant.available;
    if (label) label.textContent = variant.available ? (label.dataset.add || 'Add to cart') : (label.dataset.sold || 'Sold Out - Notify Me When It’s Available');
    if (notifyTrigger) notifyTrigger.hidden = variant.available;
    const sticky = $('[data-mobile-product-sticky]');
    const stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
    const stickyButton = sticky ? $('[data-sticky-add]', sticky) : null;
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (stickyButton) {
      stickyButton.disabled = !variant.available;
      stickyButton.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }
    if (!root.hasAttribute('data-quick-product-form') && history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }

  $$('input[type="radio"]', root).forEach(input => input.addEventListener('change', updateVariant));
  updateVariant();

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submit) submit.disabled = true;
    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!response.ok) throw new Error('add');
      toast(root.dataset.addedMessage || 'Added to bag');
      const modal = root.closest('[data-quick-modal]');
      if (modal) closeQuickModal(modal);
      await refreshCartDrawer();
      openCart();
    } catch (error) {
      toast(root.dataset.errorMessage || 'Could not add item');
    } finally {
      updateVariant();
    }
  });
});

}
bindProductForms();
window.VoydBindProductForms = bindProductForms;

$$('[data-sort-by]').forEach(select => {
  select.addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', select.value);
    location.href = url.toString();
  });
});


function openQuickModal(modal) {
  if (!modal) return;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  lockBody();
}
function closeQuickModal(modal) {
  if (!modal) return;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  unlockBodyIfClear();
}
document.addEventListener('click', event => {
  const opener = event.target.closest('[data-quick-open]');
  if (opener) {
    event.preventDefault();
    openQuickModal(document.getElementById(opener.dataset.quickOpen));
  }
  const closer = event.target.closest('[data-quick-close]');
  if (closer) closeQuickModal(closer.closest('[data-quick-modal]'));
  const modal = event.target.closest('[data-quick-modal]');
  if (modal && event.target === modal) closeQuickModal(modal);
});

const lightbox = $('[data-image-lightbox]');
const lightboxTarget = lightbox ? $('[data-lightbox-target]', lightbox) : null;
document.addEventListener('click', event => {
  const trigger = event.target.closest('[data-lightbox-image]');
  if (trigger && lightbox && lightboxTarget) {
    lightboxTarget.src = trigger.dataset.lightboxImage;
    lightboxTarget.alt = trigger.dataset.lightboxAlt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    lockBody();
  }
  const close = event.target.closest('[data-lightbox-close]');
  if (close && lightbox) {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxTarget.removeAttribute('src');
    unlockBodyIfClear();
  }
  if (lightbox && event.target === lightbox) {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightboxTarget.removeAttribute('src');
    unlockBodyIfClear();
  }
});

document.addEventListener('click', event => {
  const more = event.target.closest('[data-option-more]');
  if (more) {
    const fieldset = more.closest('.option-group');
    const extras = $$('.option-extra', fieldset);
    const opening = extras.some(el => el.hidden);
    extras.forEach(el => el.hidden = !opening);
    more.textContent = opening ? 'Show less' : 'Show more';
  }
  const notify = event.target.closest('[data-notify-open]');
  if (notify) {
    const panel = notify.parentElement.querySelector('[data-notify-form]');
    if (panel) panel.hidden = !panel.hidden;
  }
});

$$('[data-quantity-select]').forEach(select => {
  const scope = select.closest('[data-product-root]');
  const input = scope ? $('[data-qty] input[name="quantity"]', scope) : null;
  const label = scope ? $('[data-quantity-label]', scope) : null;
  if (!input) return;
  select.addEventListener('change', () => {
    input.value = select.value;
    if (label) label.textContent = select.value;
  });
  input.addEventListener('change', () => {
    if (label) label.textContent = input.value;
    const n = Math.min(10, Math.max(1, Number(input.value) || 1));
    select.value = String(n);
  });
});

let cartNoteTimer;
function persistCartNotes() {
  const note = $('[data-cart-note]');
  const gift = $('[data-gift-note]');
  const payload = {};
  if (note) payload.note = note.value;
  if (gift) payload.attributes = { 'Gift note': gift.value };
  fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)}).catch(()=>{});
}
document.addEventListener('input', event => {
  if (!event.target.matches('[data-cart-note],[data-gift-note]')) return;
  clearTimeout(cartNoteTimer);
  cartNoteTimer = setTimeout(persistCartNotes, 500);
});

refreshCartDrawer();


/* VOYD V9 Client Final: lightweight snap motion + mobile sticky CTA */
(() => {
  const snapSelectors = '.home-merch__product, .product-gallery__item, .buy-with-item';
  const snapCards = Array.from(document.querySelectorAll(snapSelectors));

  if ('IntersectionObserver' in window && snapCards.length) {
    const snapObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.62) entry.target.classList.add('is-snap-active');
        else entry.target.classList.remove('is-snap-active');
      });
    }, { threshold: [0.25, 0.62, 0.85] });
    snapCards.forEach(card => snapObserver.observe(card));
  } else {
    snapCards.forEach(card => card.classList.add('is-snap-active'));
  }

  const sticky = document.querySelector('[data-mobile-product-sticky]');
  const originalSubmit = document.querySelector('[data-product-root] .product-submit');
  const stickyAdd = sticky ? sticky.querySelector('[data-sticky-add]') : null;

  if (sticky && originalSubmit && stickyAdd) {
    stickyAdd.addEventListener('click', () => {
      if (!originalSubmit.disabled) originalSubmit.click();
    });

    if ('IntersectionObserver' in window) {
      const ctaObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        const shouldShow = !entry.isIntersecting && window.scrollY > 180;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      }, { threshold: 0.08 });
      ctaObserver.observe(originalSubmit);
    }
  }
})();


/* VOYD V9 final scroll-reveal polish */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.body.classList.add('motion-ready');
  const revealItems = document.querySelectorAll('.home-editorial-tile,.home-category-mosaic__tile,.home-community__cell,.brand-panel');
  if (!('IntersectionObserver' in window)) {
    revealItems.forEach(el => el.classList.add('is-inview'));
    return;
  }
  const revealObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  revealItems.forEach(el => revealObserver.observe(el));
})();
